export default __webpack_public_path__ + "static/media/sc13.0bb0990a.mp4";